export type AllowedNavigationType = 'paginate' | 'presentation' | 'scroll';

export function isAllowedNavigationType(type: string): type is AllowedNavigationType {
  return type === 'paginate' || type === 'presentation' || type === 'scroll';
}
